import {useCallback} from 'react';
import {OnChangeFieldValue} from '../../field/FieldValue';

export const useOnChange = (onChange: OnChangeFieldValue, fieldId: string) => {
  return useCallback(
    (v?: string | string[]) => onChange({[fieldId]: v || null}),
    [onChange, fieldId],
  );
};
